document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("form:has(.has-many-container)").forEach(form => {
        const attachInputsHandlers = () => {
            const inputs = form.querySelectorAll("input")

            inputs.forEach(input => {
                input.addEventListener("keydown", preventIfEnterKey)
            })
        }

        const preventIfEnterKey = event => {
            if (event.key === "Enter") event.preventDefault()
        }

        const observer = new MutationObserver(() => {
            attachInputsHandlers()
        })

        observer.observe(form, {childList: true, subtree: true})

        attachInputsHandlers()
    })
})
